<div class="min-h-screen flex justify-center items-center">
  <div class="flex divide-x divide-slate-300">
    <div class="pr-2.5 text-5xl">404</div>
    <div class="pl-2.5 text-2xl flex flex-col justify-center">Not found</div>
  </div>
</div>
